export const getURLParams = url => {
    const u = new URL(url);
    return Array.from(u.searchParams.entries()).reduce((acc, kv) => {
        acc[kv[0]] = kv[1] !== '' && kv[1] || true;
        return acc;
    }, {});
}